














































































import { defineComponent, ref, onMounted } from '@vue/composition-api'
import { mdiChevronLeft, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'

import { required, confirmedValidator } from '@core/utils/validation'
import { useRouter } from '@core/utils'
import useAppConfig from '@core/@app-config/useAppConfig'
import useAuth from '../composables/useAuth'
import useSweetAlert from '@core/plugins/sweetalert'
import { ActualizarClaveInterface, RecuperarClaveInterface } from '@/models'

export default defineComponent({
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const resetearForm: any = ref(null)
    const usuarioData = ref<RecuperarClaveInterface>({
      correo: null,
      nombre: null,
      usuario: null,
    })
    const resetearData = ref<ActualizarClaveInterface>({
      confirmarPassword: null,
      nuevoPassword: null,
      token: null,
    })

    const { router } = useRouter()
    const { getByToken, updatePassword } = useAuth()
    const { isLoading } = useAppConfig()
    const { showMessage } = useSweetAlert()

    const isPasswordVisible = ref(false)
    const isConfirmPasswordVisible = ref(false)

    onMounted(() => {
      resetearData.value.token = props.token
      validarToken()
    })

    const validarToken = async () => {
      isLoading.value = true
      const { ok, response } = await getByToken(props.token)

      if (ok) {
        usuarioData.value.correo = response?.correo
        usuarioData.value.nombre = response?.nombre
        usuarioData.value.usuario = response?.usuario
      } else {
        router?.push({ name: 'auth-login', replace: true })
      }

      isLoading.value = false
    }

    const handleFormSubmit = async () => {
      if (!resetearForm.value.validate()) return

      isLoading.value = true
      const { ok, response } = await updatePassword(resetearData.value)

      if (ok) {
        showMessage('Éxito!', response?.mensaje, 'success')
        router?.push({ name: 'auth-login' })
      }

      isLoading.value = false
    }

    return {
      handleFormSubmit,
      isConfirmPasswordVisible,
      isPasswordVisible,
      resetearData,
      resetearForm,
      usuarioData,
      icons: {
        mdiChevronLeft,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      validators: {
        required,
        confirmedValidator,
      },
    }
  },
})
